// A library file's source id is `file:<libraryId>` (sources-v2 D10). Dependency-free: the camera slice and the manager read it.
export const FILE_PREFIX = 'file:'

/** The pre-library selection a persisted store may still hold; reopened as the library's current file. */
export const LEGACY_FILE = 'video_file'

export const isFileSource = id => typeof id === 'string' && id.startsWith(FILE_PREFIX)

export const fileSourceId = libraryId => FILE_PREFIX + libraryId

export const libraryIdOf = id => (isFileSource(id) ? id.slice(FILE_PREFIX.length) : null)
